import { isSequentialFlow } from '../Helpers/index';

const STEP_INTERNET = {
  id: 'internet',
  label: 'Plan',
  pages: ['progressiveplan', 'popularplan'],
};

const STEP_SERVICES = {
  id: 'services',
  label: 'Services',
  pages: ['addons'],
};


const NSE_STEP_VERIFY_REVIEW = {
  id: 'verifyReview',
  label: 'Verify & Review',
  pages: ['contactinfo', 'createprofile', 'creditcheck', 'expresscheckout'],
};

const AAL_STEP_VERIFY_REVIEW = {
  id: 'verifyReview',
  label: 'Review',
  pages: ['expresscheckout'],
};

const STEP_CHECKOUT = {
  id: 'checkout',
  label: 'Checkout',
  pages: ['payment', 'expresstos'],
};

export const NSE_STEPS = [
  STEP_INTERNET,
  STEP_SERVICES,
  NSE_STEP_VERIFY_REVIEW,
  STEP_CHECKOUT,
];


export const AAL_STEPS = [
  STEP_INTERNET,
  STEP_SERVICES,
  AAL_STEP_VERIFY_REVIEW,
  STEP_CHECKOUT,
];
export const getOrderProgressSteps = (isAAL, isWifiBackupFlow) => {
  const steps = isAAL ? AAL_STEPS : NSE_STEPS;
  if (!isWifiBackupFlow) {
    return steps;
  }
  return steps.filter((step) => step.id !== 'services');
};

export const STEP_PAGE_MAP = {
  internet: 'progressiveplan.html',
  services: 'addons.html',
  checkout: 'payment.html',
};

export const getStepRedirectPage = (stepId, isAAL = false) => {
  if (stepId === 'verifyReview') {
    if (isAAL) return 'expresscheckout.html';
    return isSequentialFlow() ? 'contactinfo.html' : 'createprofile.html';
  }

  return STEP_PAGE_MAP[stepId];
};

export const getStepDataTrack = (stepLabel) => {
  const name = stepLabel;
  if (!name) return undefined;
  return JSON.stringify({ type: 'link', name: `progressbar_${name}` });
};

export const STEPPER_SUPPRESSION_RULES = [
  { page: 'addons', requiresParam: 'service' }, // Services sub-options: Perks / YouTubeTV / WHW
  { page: 'shipping' }, // Shipping option edit (from Order Review)
  { page: 'appointment' }, // Pro-setup scheduling (from Order Review)
];


export const shouldSuppressStepper = (pageName, searchParams) =>
  STEPPER_SUPPRESSION_RULES.some((rule) => {
    if (rule.page !== pageName) return false;
    if (rule.requiresParam) return Boolean(searchParams?.has?.(rule.requiresParam));
    return true;
  });
